"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../types");
var _utils = require("../../../utils");
function setSessionState(state) {
  return (0, _utils.actionCreator)(_types.BROADCAST_SET_SESSION_STATE, state);
}
var _default = exports["default"] = setSessionState;